import loadLightbox, { open } from "../Lightbox/src";

interface lightboxProps {
  imageUrl: string;
  title: string;
  name: string;
  mainBody: string;
}

export default ({ data = [], elClassName, containerClassName }: any) => {
  const elements: HTMLElement[] | null = Array.from(
    document.querySelectorAll(`.${elClassName}`)
  );

  loadLightbox({
    elClassName: "lightbox-company",
    otherClasses: [containerClassName]
  });

  if (elements !== null) {
    elements.map((el: HTMLElement, key: number) => {
      if (!data[key].disable) {
        el.addEventListener(
          "click",
          open.bind(null, {
            func: () => updateLightBox(data[key]),
            className: "lightbox-company"
          })
        );
      }
    });
  }
};

const updateLightBox = ({ title, imageUrl, mainBody }: lightboxProps) => {
  const lb = document.querySelector(".lightbox-dialogue");

  if (lb !== null) {
    lb.innerHTML = `
      <div class="lightbox-content lightbox-content--departments">
        ${
          imageUrl
            ? `
          <div class="lightbox-img">
            <img src="${imageUrl}">
          </div>`
            : ``
        }
        <div class="lightbox-description">
          <strong>${title}</strong>
          <span>${mainBody}</span>
        </div>
      </div>
    `;
  }
};
